import axios from "axios";
import rutas from "@/assets/utils/rutas.json";

const guardarData = async (params = {}) => {
  const {
    idRegistroForm,
    nameForm,
    dataJson,
    idProceso,
    tokenProceso,
    tokenFormulario,
    tokenLabAux,
    tokenLabAs400,
    tokenDev,
  } = params;

  const validNameForm = [
    "003",
    "005",
    "inf",
    "006",
    "12b",
    "12bNormal",
    "rep",
    "13a",
    "13alab",
    "017",
    "018",
    "018pre",
    "020",
    "022",
    "024",
    "060",
    "cld",
    "rc",
  ];

  if (
    !dataJson ||
    (!tokenProceso && !tokenLabAux && !tokenLabAs400 && !tokenDev)
  ) {
    console.error("No se envio data para guardar");
    return null;
  }

  if (!validNameForm.includes(nameForm)) {
    console.error("No se envio nombre correcto del form a guardar");
    return null;
  }

  const query = `
    mutation MyMutation(
      $idFormulario    : String!,
      $jsonData        : String!, 
      $procId          : ID,
      $tokenProceso    : String, 
      $tokenFormulario : String, 
      $tokenLabAs400   : String,
      $tokenLabAux     : String,
      $tokenDev        : String,
      $idFormExistente : ID
    ) {
      saveDataFormProc(
        idFormulario    : $idFormulario,
        jsonData        : $jsonData, 
        procId          : $procId,
        tokenProceso    : $tokenProceso,
        tokenFormulario : $tokenFormulario,
        tokenLabAs400   : $tokenLabAs400,
        tokenDev        : $tokenDev,
        tokenLabAux     : $tokenLabAux,
        idFormExistente : $idFormExistente
      ) {
        message
        status
      }
    }
  `;

  const variables = {
    idFormulario: nameForm,
    jsonData: dataJson,
    procId: idProceso || null,
    tokenProceso: tokenProceso || null,
    tokenLabAs400: tokenLabAs400 || null,
    tokenLabAux: tokenLabAux || null,
    tokenDev: tokenDev || null,
    tokenFormulario: tokenFormulario || null,
    idFormExistente: idRegistroForm,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const response2 = response.data.data.saveDataFormProc;
    if (response2.status !== "success") return null;

    return true;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getByProceso = async (tokenProceso, tipoFormulario = null) => {
  if (!tokenProceso) return null;

  const query = `
    query qrallProcedimientoclinico($tokenProceso: String) {
      allProcedimientoclinico( tokenProceso: $tokenProceso ) {
        proclinic {
          id
          token
          fechaProgramada
          estadoProceso
          consultamedica {
          token
          cita{
          paciente{
          persona{
          primerNombre
          primerApellido
          identificacion
          }}}}
          
          procedimientoformularioSet {
            id
            token
            dataJson
            idFormulario
          }
          
        }
        dataarchivo
        total
        status
        message
      }
    }
  `;

  const variables = {
    tokenProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status !== 200) return null;

    const response2 = response.data.data.allProcedimientoclinico;
    if (response2.status !== "success") return null;

    const idProceso = response2.proclinic?.[0]?.id;
    const tokenAtencion = response2.proclinic?.[0]?.consultamedica?.token;
    const identificacion =
      response2.proclinic?.[0]?.consultamedica?.cita?.paciente?.persona
        ?.identificacion;

    let data = response2.proclinic?.[0]?.procedimientoformularioSet;

    if (!data) return null;
    if (tipoFormulario) {
      data = data.filter((item) => item.idFormulario === tipoFormulario);
    }
    return {
      idProceso: idProceso || null,
      tokenAtencion: tokenAtencion,
      data: data,
      identificacion: identificacion || null,
    };
  } catch (error) {
    console.error("Error fetching laboratorio:", error);
    return null;
  }
};

const getByTokenPrincipal = async (tokenPrincipal, tipoFormulario = null) => {
  if (!tokenPrincipal) return null;

  const query = `
    query GetDataFormulariosProcesos(
      $tokenPrincipal: String
    ) {
      getDataFormulariosProcesos(
        tokenPrincipal: $tokenPrincipal
      ) {
        formularios {
          id
          token
          estado
          idFormulario
          dataJson
          fechaCreacion
          usuarioCreador {
            id
            username
          }
        }
        message
        status
      }
    }
  `;

  const variables = {
    tokenPrincipal,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const response2 = response.data.data.getDataFormulariosProcesos;
    if (response2.status !== "success") return null;

    const data = response2.formularios;
    if (!data) return null;
    if (!tipoFormulario) return data;

    const dataFilter = data.filter(
      (item) => item.idFormulario === tipoFormulario
    );
    if (!dataFilter || !dataFilter.length) {
      return null;
    }
    return dataFilter;
  } catch (error) {
    console.error("Error fetchinng formularios de procedimientos:", error);
    return null;
  }
};

const obtenerDescansoMedicoProc = async (tokenFormulario) => {
  if (!tokenFormulario) return null;

  const query = `
  query generateDescansoProcedimientoPdf($tokenFormulario: String!) {
    generateDescansoProcedimientoPdf(tokenFormulario: $tokenFormulario)
  }
`;

  const variables = {
    tokenFormulario,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const response2 = response.data.data.generateDescansoProcedimientoPdf;
    console.log(response2);

    const data = response2;
    if (!data) return null;

    return data;
  } catch (error) {
    console.error("Error fetchinng formularios de procedimientos:", error);
    return null;
  }
};

const obtenerFormProcDataByToken = async (tokenFormProc) => {
  if (!tokenFormProc) return null;

  const query = `
    query obtenerFormProcDataByToken(
      $tokenFormProc: String
    ) {
      obtenerFormProcDataByToken(
        tokenFormProc: $tokenFormProc
      ) {
        formulario {
          id
          token
          estado
          idFormulario
          dataJson
          fechaCreacion
          procedimientoCita {
          consultamedica {
          token
          cita {
          paciente {
          persona {
          identificacion
          primerApellido
          primerNombre}}}}
          procedimiento{
          id
          codigo
          descripcion}}
          usuarioCreador {
            id
            username
          }
        }
        message
        status
      }
    }
  `;

  const variables = {
    tokenFormProc,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const response2 = response.data.data.obtenerFormProcDataByToken;
    if (response2.status !== "success") return null;

    console.log("response 2", response2);

    const data = response2.formulario;

    if (!data) return null;

    // Guard rails in case backend fields come null so the caller still receives data
    const nombreProcedimiento =
      data?.procedimientoCita?.procedimiento?.descripcion || "";
    const pacientePersona =
      data?.procedimientoCita?.consultamedica?.cita?.paciente?.persona;
    const nombrePaciente = pacientePersona
      ? `${pacientePersona.identificacion} - ${pacientePersona.primerApellido} ${pacientePersona.primerNombre}`
      : "";

    return data;
  } catch (error) {
    console.error("Error fetching formulario de procedimiento:", error);
    return null;
  }
};

const generar12bProc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate012bPdf($idproc : ID!){
     generate012bPdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate012bPdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 12b:", error);
    return null;
  }
};
const generar12bNormalProc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate012bNormalPdf($idproc : ID!){
     generate012bNormalPdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate012bNormalPdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 12b:", error);
    return null;
  }
};

const generar005Proc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate005Pdf($idproc : ID!){
     generate005Pdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate005Pdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 005:", error);
    return null;
  }
};

const generar006Proc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate006Pdf($idproc : ID!){
     generate006Pdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate006Pdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 006:", error);
    return null;
  }
};

const generar13aProc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate013aPdf($idserc : ID!, $tservice : String ){
     generate013aPdf(idserc: $idserc, tservice: $tservice) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idserc: idProceso,
    tservice: "proc",
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate013aPdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 013a:", error);
    return null;
  }
};

const generar018Proc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate018Pdf($idproc : ID!){
     generate018Pdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate018Pdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 005:", error);
    return null;
  }
};

const generar017Proc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate017Pdf($idproc : ID!){
     generate017Pdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate017Pdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 017:", error);
    return null;
  }
};
const generar018PreProc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate018prePdf($idproc : ID!){
     generate018prePdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate018prePdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar preanestesico:", error);
    return null;
  }
};

const generar020Proc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate020Pdf($idproc : ID!){
     generate020Pdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate020Pdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 005:", error);
    return null;
  }
};

const generar022Proc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate022Pdf($idproc : ID!){
     generate022Pdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate022Pdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 005:", error);
    return null;
  }
};

const generar060Proc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate060Pdf($idproc : ID!){
     generate060Pdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate060Pdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 005:", error);
    return null;
  }
};

const generar003Proc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate003Pdf($idproc : ID!){
     generate003Pdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate003Pdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 003:", error);
    return null;
  }
};

const generar024Proc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generate024Pdf($idproc : ID!){
     generate024Pdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate024Pdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar 024:", error);
    return null;
  }
};

const generarRiesgoCaidasProc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generateInformecaidasPdf($idproc : ID!){
     generateInformecaidasPdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generateInformecaidasPdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar el informe caidas:", error);
    return null;
  }
};
const generarCheckListProc = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generateChecklistdocPdf($idproc : ID!){
     generateChecklistdocPdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generateChecklistdocPdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar el informe caidas:", error);
    return null;
  }
};
const generarInformeTecnico = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
  query generateInformeTecnicoPdf($idproc : ID!){
     generateInformeTecnicoPdf(idproc: $idproc) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const pdfBase64 = response.data.data.generateInformeTecnicoPdf?.pdfBase64;

    if (!pdfBase64) return null;
    return pdfBase64;
  } catch (error) {
    console.error("Error al generar el informe tecnico:", error);
    return null;
  }
};

const descargarZipInformes = async (idProceso) => {
  if (!idProceso) return null;

  const query = `
        query MyQuery($idproc: ID!) {
          generateInformesZipPdfNew(idproc: $idproc) {                       
            message
            pdfBase64
            nameFile
          }
        }
      `;

  const variables = {
    idproc: idProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const arregloPdfBase64 = response.data.data.generateInformesZipPdfNew;
    console.log("se descarga arreglo pdf", arregloPdfBase64);

    if (!arregloPdfBase64) return null;
    return arregloPdfBase64;
  } catch (error) {
    console.error("ERROR AL GENERAR EL ZIP DE LOS PDFS:", error);
    return null;
  }
};

export const procedimientosFormulariosService = {
  guardarData,
  getByProceso,
  getByTokenPrincipal,
  obtenerFormProcDataByToken,
  generar003Proc,
  generar12bProc,
  generar12bNormalProc,
  generar005Proc,
  generar006Proc,
  generar13aProc,
  generar017Proc,
  generar018Proc,
  generar020Proc,
  generar022Proc,
  generar024Proc,
  generar060Proc,
  generar018PreProc,
  generarRiesgoCaidasProc,
  generarInformeTecnico,
  generarCheckListProc,
  descargarZipInformes,
  obtenerDescansoMedicoProc,
};
